import { IAssignedPatients, PATIENT_STATUS } from "@home-health-notify/domain";
import PatientStatusImage from "../../common/PatientStatusImage";
import { GROUP_AVATAR_SIZE } from "../../utils/AvatarUtils";
import {
  AssignedPatientWrapper,
  PatientsCount,
  PatientsCountBadge,
  StatusImgOutline,
} from "./AssignedPatients.style";

interface AssignedPatientProps extends IAssignedPatients {
  openModal: (patientStatus: PATIENT_STATUS) => void;
}

const AssignedPatient = ({
  patientStatus,
  patients,
  openModal,
}: AssignedPatientProps) => {
  return (
    <>
      <AssignedPatientWrapper
        data-testid="assigned-patient-wrapper"
        onClick={() => openModal(patientStatus)}
      >
        <StatusImgOutline>
          <PatientStatusImage
            status={Number(patientStatus)}
            size={GROUP_AVATAR_SIZE.LARGE}
            testId="status-img"
          />
        </StatusImgOutline>
        <PatientsCountBadge data-testid="patient-count">
          <PatientsCount>{patients.length || 0}</PatientsCount>
        </PatientsCountBadge>
      </AssignedPatientWrapper>
    </>
  );
};

export default AssignedPatient;
